import { fromJS, Map, Record } from '@gonfalon/immutable-shim/immutableShim';

import { type AccessReason } from '../types';

type AccessDecisionType = {
  isAllowed: boolean;
  appliedRoleName: string;
  isServiceToken: boolean;
  customMessage: string;
  reason: AccessReason;
};

export class AccessDecision extends Record<AccessDecisionType>({
  isAllowed: true,
  reason: Map(),
  appliedRoleName: '',
  isServiceToken: false,
  customMessage: '',
}) {
  getActionReason() {
    if (this.customMessage) {
      return this.customMessage;
    }

    if (!this.isAllowed) {
      return this.appliedRoleName
        ? `The "${this.appliedRoleName}" role does not allow you to perform this action`
        : "Your permissions don't allow you to perform this action";
    }
    return '';
  }

  getModifyFieldReason() {
    if (this.customMessage) {
      return this.customMessage;
    }
    if (!this.isAllowed) {
      return this.appliedRoleName
        ? `The "${this.appliedRoleName}" role does not allow you to modify this field`
        : 'Your permissions don’t allow you to modify this field';
    }
    return '';
  }

  getChangeSettingReason() {
    if (this.customMessage) {
      return this.customMessage;
    }
    if (!this.isAllowed) {
      return this.appliedRoleName
        ? `The "${this.appliedRoleName}" role does not allow you to change this setting`
        : 'Your permissions don’t allow you to change this setting';
    }
    return '';
  }

  getServiceTokenReason() {
    if (this.customMessage) {
      return this.customMessage;
    }
    return this.isServiceToken ? 'You may not change the roles of a service token' : '';
  }
}

export function createAccessDecision(props = {}) {
  if (props instanceof AccessDecision) {
    return props;
  }
  return new AccessDecision(fromJS(props));
}
